import { render, staticRenderFns } from "./ActivitiesChildren.vue?vue&type=template&id=b8dd82a0&"
import script from "./ActivitiesChildren.vue?vue&type=script&lang=js&"
export * from "./ActivitiesChildren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports